/* Ridge Studios — shared NZ/AU/CA delivery estimate calculations.
 * Used by terrain-preview.js and collapsible-content.liquid.
 * Manufacturing runs in Auckland; both widgets use the same NZ production calendar.
 * International transit is indicative business days, excluding destination holidays/customs.
 */
(function () {
  'use strict';
  if (window.RidgeDelivery) return;
  const RIDGE_MATARIKI_DATES = {
    2026:"07-10",2027:"06-25",2028:"07-14",2029:"07-06",2030:"06-21",
    2031:"07-11",2032:"07-02",2033:"06-24",2034:"07-07",2035:"06-29",
    2036:"07-18",2037:"07-10",2038:"06-25",2039:"07-15",2040:"07-06",
    2041:"07-19",2042:"07-11",2043:"07-03",2044:"06-24",2045:"07-07",
    2046:"06-29",2047:"07-19",2048:"07-03",2049:"06-25",2050:"07-15",
    2051:"06-30",2052:"06-21"
  };
  function ridgeUtcDate(year, month, day) { return new Date(Date.UTC(year, month - 1, day, 12)); }
  function ridgeDateKey(date) { return date.toISOString().slice(0, 10); }
  function ridgeMoveDay(date, offset) {
    const next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + offset);
    return next;
  }
  function ridgeFirstMonday(year, month, ordinal) {
    const d = ridgeUtcDate(year, month, 1);
    return ridgeMoveDay(d, (8 - d.getUTCDay()) % 7 + (ordinal - 1) * 7);
  }
  function ridgeEasterSunday(year) {
    // Gregorian computus. Used to exclude Good Friday and Easter Monday.
    const a = year % 19, b = Math.floor(year / 100), c = year % 100;
    const d = Math.floor(b / 4), e = b % 4;
    const f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30;
    const i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k + 70) % 7;
    const m = Math.floor((a + 11 * h + 22 * l) / 451);
    const v = h + l - 7 * m + 114;
    return ridgeUtcDate(year, Math.floor(v / 31), v % 31 + 1);
  }
  const ridgeHolidayCache = new Map();
  function ridgeNzHolidays(year) {
    if (ridgeHolidayCache.has(year)) return ridgeHolidayCache.get(year);
    const dates = new Set();
    function add(date) { dates.add(ridgeDateKey(date)); }
    function observedPair(first, second) {
      // Reserve genuine weekday dates before assigning weekend substitutions.
      [first, second].forEach(d => { if (d.getUTCDay() > 0 && d.getUTCDay() < 6) add(d); });
      [first, second].forEach(d => {
        if (d.getUTCDay() === 0 || d.getUTCDay() === 6) {
          let substitute = ridgeMoveDay(d, 1);
          while (substitute.getUTCDay() === 0 || substitute.getUTCDay() === 6 || dates.has(ridgeDateKey(substitute))) {
            substitute = ridgeMoveDay(substitute, 1);
          }
          add(substitute);
        }
      });
    }
    observedPair(ridgeUtcDate(year,1,1),ridgeUtcDate(year,1,2));
    observedPair(ridgeUtcDate(year,12,25),ridgeUtcDate(year,12,26));
    [ridgeUtcDate(year,2,6),ridgeUtcDate(year,4,25)].forEach(date => {
      while (date.getUTCDay() === 0 || date.getUTCDay() === 6) date = ridgeMoveDay(date,1);
      add(date);
    });
    const easter = ridgeEasterSunday(year);
    add(ridgeMoveDay(easter, -2));
    add(ridgeMoveDay(easter, 1));
    add(ridgeFirstMonday(year, 6, 1));
    add(ridgeFirstMonday(year, 10, 4));
    if (RIDGE_MATARIKI_DATES[year]) dates.add(year + "-" + RIDGE_MATARIKI_DATES[year]);
    // Production ships from Auckland. The holiday nearest 29 January is local to Auckland.
    const jan29 = ridgeUtcDate(year, 1, 29);
    const previousMonday = ridgeMoveDay(jan29, -((jan29.getUTCDay() + 6) % 7));
    const nextMonday = ridgeMoveDay(jan29, (8 - jan29.getUTCDay()) % 7);
    add(Math.abs(nextMonday - jan29) < Math.abs(previousMonday - jan29) ? nextMonday : previousMonday);
    ridgeHolidayCache.set(year, dates);
    return dates;
  }
  function ridgeIsWorkingDay(date) {
    const day = date.getUTCDay();
    return day !== 0 && day !== 6 && !ridgeNzHolidays(date.getUTCFullYear()).has(ridgeDateKey(date));
  }
  function ridgeAddWorkingDays(start, count) {
    let current = new Date(start.getTime()), remaining = count;
    while (remaining > 0) {
      current = ridgeMoveDay(current, 1);
      if (ridgeIsWorkingDay(current)) remaining--;
    }
    return current;
  }
  function ridgeTodayInNz() {
    const parts = new Intl.DateTimeFormat("en-NZ", {
      timeZone:"Pacific/Auckland", year:"numeric", month:"2-digit", day:"2-digit"
    }).formatToParts(new Date());
    const values = {};
    parts.forEach(part => { values[part.type] = part.value; });
    return ridgeUtcDate(Number(values.year), Number(values.month), Number(values.day));
  }
  function ridgeFormatDay(date, showYear) {
    return new Intl.DateTimeFormat("en-NZ", {
      timeZone:"UTC", day:"numeric", month:"short", ...(showYear ? {year:"numeric"} : {})
    }).format(date);
  }

  const COUNTRY_LABELS = {
    NZ: {name: 'NZ', shipping: 'NZ shipping after making'},
    AU: {name: 'Australian', shipping: 'Shipping to Australia after making'},
    CA: {name: 'Canadian', shipping: 'Shipping to Canada after making'}
  };
  const DEFAULT_SHIPPING = {
    NZ: {min: 2, max: 3},
    AU: {min: 5, max: 10},
    CA: {min: 8, max: 15}
  };
  function clamp(value, fallback, minimum, maximum) {
    if (value === '' || value === null || value === undefined) return fallback;
    const n = Number(value);
    return Number.isFinite(n) ? Math.min(maximum, Math.max(minimum, Math.round(n))) : fallback;
  }
  function formatRange(min, max) {
    return min === max ? min + ' working days' : min + '–' + max + ' working days';
  }
  function getEstimate(options) {
    const country = String(options.country || 'NZ').toUpperCase();
    if (!COUNTRY_LABELS[country]) return null;
    const defaults = DEFAULT_SHIPPING[country];
    const productionA = clamp(options.productionMin, 5, 3, 10);
    const productionB = clamp(options.productionMax, 5, 3, 10);
    const shippingA = clamp(options.shippingMin, defaults.min, 1, 40);
    const shippingB = clamp(options.shippingMax, defaults.max, 1, 40);
    const prodMin = Math.min(productionA, productionB);
    const prodMax = Math.max(productionA, productionB);
    const shipMin = Math.min(shippingA, shippingB);
    const shipMax = Math.max(shippingA, shippingB);
    const today = ridgeTodayInNz();
    const earlyProduction = ridgeAddWorkingDays(today, prodMin);
    const lateProduction = ridgeAddWorkingDays(today, prodMax);
    const earliestDelivery = ridgeAddWorkingDays(earlyProduction, shipMin);
    const latestDelivery = ridgeAddWorkingDays(lateProduction, shipMax);
    const showYear = earliestDelivery.getUTCFullYear() !== latestDelivery.getUTCFullYear();
    const isNZ = country === 'NZ';
    return {
      country,
      heading: 'Estimated ' + COUNTRY_LABELS[country].name + ' delivery',
      ariaLabel: 'Estimated ' + (isNZ ? 'New Zealand' : country === 'AU' ? 'Australian' : 'Canadian') + ' delivery',
      dates: ridgeFormatDay(earliestDelivery, showYear) + ' – ' + ridgeFormatDay(latestDelivery, showYear),
      order: 'If ordered today, ' + ridgeFormatDay(today, true),
      making: formatRange(prodMin, prodMax),
      shippingLabel: COUNTRY_LABELS[country].shipping,
      shippingDays: formatRange(shipMin, shipMax),
      note: isNZ
        ? 'Estimated dates exclude weekends, NZ national public holidays and Auckland Anniversary. Regional holidays and courier delays may affect delivery.'
        : 'Estimated dates use NZ working days and exclude NZ public holidays. Destination holidays, customs clearance and courier delays may affect arrival.'
    };
  }

  /* 2026 Christmas dispatch cutoffs from the NZ Post email supplied by Ridge Studios.
   * These are carrier SEND-BY dates, not customer order deadlines.
   * The customer order dates below subtract the configured SLOWEST production time
   * plus a further two NZ working days for packing/printing contingencies.
   * Do not reuse for 2027 without checking the carrier's new cutoffs.
   */
  const RIDGE_CHRISTMAS_2026 = {
    NZ: {economy: '2026-12-18', courier: '2026-12-22'},
    AU: {economy: '2026-12-09', courier: '2026-12-14'}
  };
  const RIDGE_CHRISTMAS_EXTRA_WORKING_DAYS = 2;
  function ridgeParseIsoDate(iso) {
    const parts = iso.split('-').map(Number);
    return ridgeUtcDate(parts[0], parts[1], parts[2]);
  }
  function ridgeSubtractWorkingDays(end, count) {
    let current = new Date(end.getTime()), remaining = count;
    while (remaining > 0) {
      current = ridgeMoveDay(current, -1);
      if (ridgeIsWorkingDay(current)) remaining--;
    }
    return current;
  }
  function getChristmas(options) {
    options = options || {};
    const country = String(options.country || 'NZ').toUpperCase();
    const cutoffs = RIDGE_CHRISTMAS_2026[country];
    if (!cutoffs) return null; // No Canadian deadline advertised.
    const today = ridgeTodayInNz();
    if (ridgeDateKey(today) < '2026-10-30' || ridgeDateKey(today) > '2026-12-25') return null;
    const slowestProduction = Math.max(
      clamp(options.productionMin, 5, 3, 10),
      clamp(options.productionMax, 5, 3, 10)
    );
    const workingDaysBeforeDispatch = slowestProduction + RIDGE_CHRISTMAS_EXTRA_WORKING_DAYS;
    function service(code, label) {
      const dispatch = ridgeParseIsoDate(cutoffs[code]);
      const orderByDate = ridgeSubtractWorkingDays(dispatch, workingDaysBeforeDispatch);
      return {
        label,
        orderBy: ridgeFormatDay(orderByDate, false),
        dispatchBy: ridgeFormatDay(dispatch, false),
        orderByISO: ridgeDateKey(orderByDate),
        expired: today.getTime() > orderByDate.getTime()
      };
    }
    const economy = service('economy', 'Economy');
    const courier = service('courier', 'Courier');
    return {
      country,
      year: 2026,
      economy,
      courier,
      productionDays: slowestProduction,
      bufferDays: RIDGE_CHRISTMAS_EXTRA_WORKING_DAYS,
      pastCourierDeadline: courier.expired,
      message: courier.expired
        ? 'Christmas arrival is no longer expected for new custom orders.'
        : 'Recommended order-by dates for the best chance of Christmas delivery.',
      disclaimer: 'Based on NZ Post 2026 recommended sending dates, up to ' + slowestProduction +
        ' working days to make your order, and ' + RIDGE_CHRISTMAS_EXTRA_WORKING_DAYS +
        ' extra NZ working days to prepare for dispatch. Courier applies only if that service is used. ' +
        'Not guaranteed; rural/remote addresses, customs and carrier delays may require earlier ordering.'
    };
  }

  // Render the same Christmas message inside either the FAQ or configurator widget.
  // Insert at the TOP of the existing delivery estimate; never duplicate it.
  function renderChristmas(deliveryCard, options) {
    if (!deliveryCard) return null;
    const result = getChristmas(options);
    let block = deliveryCard.querySelector('[data-ridge-christmas]');
    if (!result) {
      if (block) block.hidden = true;
      return null;
    }
    if (!block) {
      block = document.createElement('div');
      block.className = 'ridge-christmas-card';
      block.setAttribute('data-ridge-christmas', '');
      block.innerHTML =
        '<div class="ridge-christmas-card__heading">🎄 Christmas delivery 2026</div>' +
        '<p class="ridge-christmas-card__message" data-ridge-christmas-message></p>' +
        '<div class="ridge-christmas-card__rows">' +
          '<div><span>Economy</span><strong data-ridge-christmas-economy></strong></div>' +
          '<div><span>Courier</span><strong data-ridge-christmas-courier></strong></div>' +
        '</div>' +
        '<small class="ridge-christmas-card__note" data-ridge-christmas-note></small>';
      deliveryCard.insertBefore(block, deliveryCard.firstChild);
    }
    block.hidden = false;
    // Avoid needless DOM mutations: the configurator watches for new delivery cards.
    function setText(selector, value) {
      const element = block.querySelector(selector);
      if (element.textContent !== value) element.textContent = value;
    }
    setText('[data-ridge-christmas-message]', result.message);
    setText('[data-ridge-christmas-economy]', result.economy.expired
      ? 'Order window passed (' + result.economy.orderBy + ')'
      : 'Order by ' + result.economy.orderBy);
    setText('[data-ridge-christmas-courier]', result.courier.expired
      ? 'Order window passed (' + result.courier.orderBy + ')'
      : 'Order by ' + result.courier.orderBy);
    setText('[data-ridge-christmas-note]', result.disclaimer);
    return result;
  }

  window.RidgeDelivery = {getEstimate, getChristmas, renderChristmas};
})();
